module.exports = __webpack_public_path__ + "media/images/logo-event/LogoEvento-1a3378a66f59580b1a1566c309b8647f.png";